webpackJsonp([175765443188397],{

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(8);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(260);
	
	var _Jumbotron = __webpack_require__(17);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GamesPage = function (_Component) {
	  _inherits(GamesPage, _Component);
	
	  function GamesPage() {
	    _classCallCheck(this, GamesPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  GamesPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "GamesPage" },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Games | " + _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_Jumbotron2.default, { message: "Nothing to see here." }),
	      _react2.default.createElement(
	        "div",
	        { className: "GamesPage__content Container" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "News coming soon, follow us on Twitter."
	        )
	      )
	    );
	  };
	
	  return GamesPage;
	}(_react.Component);
	
	exports.default = GamesPage;
	module.exports = exports["default"];

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-games-jsx-db16980608c426137f36.js